export enum PrintReceiptEnum {
  Disabled = 'Disabled',
  UserChoice = 'UserChoice',
  ForcePrint = 'ForcePrint',
}
